export default from './Document';



// WEBPACK FOOTER //
// ./src/containers/Document/index.js